/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { X } from '@entrata/portals-common/lib/icons'
import { WHITE } from 'constants/theme'

import styled from '@emotion/styled'

const StyledButton = styled('button')`
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 8px;
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: ${WHITE};
  transition: background 0.25s ease-out;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.primary.red};
  }

  &:focus {
    background: white;
    outline: none;
  }
  
  svg{
    color: ${({ theme }) => theme.secondary.base};
  }
`

const DialogClose = props => (
  <StyledButton {...props}>
    <X size={24} />
  </StyledButton>
)

DialogClose.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default DialogClose
